import { Button, Text, ModalWindow, MultilineInput, Ref, TextInput } from "@tblabs/truffle";
import { Device } from "src/Services/Device.1";


export class FileEditWindow extends ModalWindow
{
    private loadButton = new Button("Load").Class("uk-button uk-button-primary").FloatLeft();
    private saveButton = new Button("Save").Class("uk-button uk-button-primary").FloatRight();

    constructor(device: Device)
    {
        super(`📜 ${device.Id} File editor`);
        this.WidthPercent(86);

        const fileDir = new Ref<string>("").Storable("file-dir");
        const fileContent = new Ref<string>("");
        const status = new Ref<string>("");

        device.OnFileLoad.Subscribe((dir: string, content: string) =>
        {
            fileContent.value = content;
            status.value = "File loaded";
            this.loadButton.Label("Load");
        });

        device.OnFileProblem.Subscribe(problem =>
        {
            status.value = problem;
            this.loadButton.Label("Load");
            this.saveButton.Label("Save");
        });

        device.OnFileSaved.Subscribe(dir =>
        {
            status.value = "File saved";
            this.saveButton.Label("Save");
        });

        this.loadButton.OnClick(() =>
        {
            this.loadButton.Label("Loading...");
            device.LoadFile(fileDir.value);
        });

        this.saveButton.OnClick(() =>
        {
            this.saveButton.Label("Saving...");
            device.SaveFile(fileDir.value, fileContent.value);
        });

        this.AddContent(
            new TextInput(fileDir).Width(100, "%").MarginBottom(8).Placeholder("File path"),
            new MultilineInput(fileContent).Rows(16).FullWidth().Placeholder("File Content"),
        );

        this.footer.TextAlignCenter();
        this.AddToFooter(
            this.loadButton,
            new Text(status).DisplayInlineBlock().MarginTop(8),
            this.saveButton
        );
    }
}
